<template>
    <component :is="tagName" v-bind="attrs()" v-if="visible" :class="classNames" @click="onClick">
        <slot v-if="loaded" name="default" />
        <Placeholder v-else :image="true" :width="36" :height="36" class="mb-n1">
            >
        </Placeholder>
    </component>
</template>

<script lang="ts" setup>
import type { Header } from '../helpers';

defineOptions({
    name: 'ListViewImage',
    inheritAttrs: false
});

export interface Props
{
    index?: number;
    header?: Header;
}

const props = withDefaults(defineProps<Props>(), {});
const loaded = inject<Ref<boolean>>('loaded');
const layout = inject<Ref<string>>('layout');
const item = inject<ComputedRef<any>>('item');
const rowClick = inject<(item: any, index: number) => void>('row-click');

const table = computed(() => layout.value == 'table');
const tagName = computed(() => table.value ? 'td' : 'div');
const classNames = computed(() => table.value ? 'pointer p-1' : '');
const visible = computed(() => props.header.visible);

const $attrs = useAttrs();
const attrs = (): Record<string, any> => only($attrs, 'class', 'style');

const onClick = (): void =>
{
    if (table.value && loaded && rowClick)
    {
        rowClick(item.value, props.index);
    }
};
</script>
